import React from 'react';
import palette from '../../theme/palette';

export const BreadcrumbChevron = () => (
  <div className="breadcrumbs-chevron">
    <i
      className="material-symbols-outlined"
      style={{ color: palette.breadcrumbLastItem, fontSize: 18, verticalAlign: 'text-top', position: 'relative', top: '-1px' }}
    >
      chevron_right
    </i>
  </div>
);
